export default __webpack_public_path__ + "static/media/3d-glasses.defc566f.png";